/**
 * Whether claims are open in this person's region yet.
 *
 * Decided by the server (canFileClaims on /auth/status, from its
 * config/claimRegions.mjs): production takes claims from East Africa only for
 * now (2026-10-28), and the test environment from every region. The client
 * cannot tell the two apart - it forces test mode - so it never works this out
 * for itself.
 *
 * A user from a server that predates the flag has no canFileClaims. That reads
 * as open: the server still refuses anything it should.
 */
export const claimsOpenFor = (user) => user?.canFileClaims !== false;

/** "West-Africa" -> "West Africa", for use in a sentence. */
export const regionName = (region) => (region ? String(region).replace(/-/g, ' ') : 'your region');

export const claimsComingSoonMessage = (region) =>
  `Claims are coming to ${regionName(region)} soon. For now they can only be filed in East Africa.`;
